import { makeContextModule } from '@cian/react-utils';
import { TDeviceType } from '@cian/ui-kit';

export const { Context: DeviceTypeContext, useContext: useDeviceType } = makeContextModule<TDeviceType>({
  contextName: 'DeviceTypeContext',
});
